import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { Filter } from '../models/filters.model';

@Injectable({ providedIn: 'root' })
export class HttpService {
  protected url = '';
  protected baseUrl = '';
  constructor(public http: HttpClient) {}

  async get(id: string): Promise<any> {
    const DATA = await firstValueFrom(this.getObservable(id));
    return DATA;
  }

  getObservable(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}${this.url}/${id}`);
  }

  async getAll(filter: Filter = new Filter()): Promise<any> {
    const DATA = await firstValueFrom(this.getAllObservable(filter));
    return DATA;
  }

  getAllObservable(filter: Filter = new Filter()): Observable<any> {
    const queryString = filter.toQueryString();
    return this.http.get(`${this.baseUrl}${this.url}?${queryString}`);
  }

  async getWithCurrency(id: string, currency: string): Promise<any> {
    const DATA = await firstValueFrom(
      this.getObservableWithCurrency(id, currency)
    );
    return DATA;
  }

  getObservableWithCurrency(id: string, currency: string): Observable<any> {
    const CLEAN_STRING = currency.replace(/^"+|"+$/g, '');
    const headers = new HttpHeaders({
      currency: CLEAN_STRING,
    });

    return this.http.get(`${this.baseUrl}${this.url}/${id}`, { headers });
  }

  async post(
    body: Record<string, any>,
    id: string
  ): Promise<HttpResponse<any>> {
    const RESPONSE = await firstValueFrom(this.postObservable(body, id));
    return RESPONSE;
  }

  postObservable(
    body: Record<string, any>,
    id: string
  ): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      `${this.baseUrl}${this.url}/${id}`,
      body,
      {
        responseType: 'json',
        observe: 'response',
      }
    );
  }

  async postWithCurrency(
    body: Record<string, any>,
    id: string,
    currency: string
  ): Promise<any> {
    const DATA = await firstValueFrom(
      this.postObservableWithCurrency(body, id, currency)
    );
    return DATA;
  }

  postObservableWithCurrency(
    body: Record<string, any>,
    id: string,
    currency: string
  ): Observable<HttpResponse<any>> {
    const CLEAN_STRING = currency.replace(/^"+|"+$/g, '');
    const headers = new HttpHeaders({
      currency: CLEAN_STRING,
    });

    return this.http.post<HttpResponse<any>>(
      `${this.baseUrl}${this.url}/${id}`,
      body,
      {
        headers,
        responseType: 'json',
        observe: 'response',
      }
    );
  }

  async put(body: Record<string, any>, id: string): Promise<HttpResponse<any>> {
    const RESPONSE = await firstValueFrom(this.putObservable(body, id));
    return RESPONSE;
  }

  putObservable(
    body: Record<string, any>,
    id: string
  ): Observable<HttpResponse<any>> {
    return this.http.put<HttpResponse<any>>(
      `${this.baseUrl}${this.url}/${id}`,
      body,
      {
        responseType: 'json',
        observe: 'response',
      }
    );
  }
  

  async delete(id: string): Promise<HttpResponse<any>> {
    const RESPONSE = await firstValueFrom(this.deleteObservable(id));
    return RESPONSE;
  }

  deleteObservable(id: string): Observable<HttpResponse<any>> {
    return this.http.delete<HttpResponse<any>>(
      `${this.baseUrl}${this.url}/${id}`,
      {
        responseType: 'json',
        observe: 'response',
      }
    );
  }
}
